<template>
  <FormCheckboxField :boxLabel="requiredLabel" v-model="isRequired" @change="onInput()"/>

  <div v-if="isRequired">
    <FormCheckboxGroupField :label="whichTypesLabel" :options="assistanceTypes" v-model="selectedTypes" @change="onInput()" stacked />

    <HalfColumn>
        <FormTextField label="Any other assistance?" v-model="assistance.otherInfo" trimmed @change="onInput()"/>
    </HalfColumn>

    <FormRadioGroupField :label="frequencyLabel" :options="GeorgiaDfcsBenefits.AssistanceFrequency" v-model="assistance.frequency" @change="onInput()"/>
  </div>

</template>

<script lang="ts" setup>
import { GeorgiaDfcsBenefits } from "@minicity/core";
import { onMounted, ref } from "vue";

enum assistanceTypes {
    "Sign language interpreter" = "signLanguageInterpreter",
    "TTY" = "TTY",
    "Large print" = "largePrint",
    "Electronic communication (email)" = "email",
    "Braille" = "braille",
    "Video relay" = "videoRelay",
    "Cued speech interpreter" = "cuedSpeechInterpreter",
    "Oral interpreter" = "oralInterpreter",
    "Tactile interpreter" = "tactileInterpreter",
    "Telephone call reminder of program deadlines" = "telephoneCallReminder",
    "Telephonic signature" = "telephonicSignature",
    "Face-to-face interview" = "faceToFaceInterview",
}

const props = defineProps<{
  modelValue?: Partial<GeorgiaDfcsBenefits.RequiredAssistance>|null,

  requiredLabel: string,
  whichTypesLabel: string,
  frequencyLabel: string,
}>();

const isRequired = ref<boolean|null>(null);
const selectedTypes = ref<string[]>([]);
const assistance = ref<GeorgiaDfcsBenefits.RequiredAssistance>({
  signLanguageInterpreter: false,
  TTY: false,
  largePrint: false,
  email: false,
  braille: false,
  videoRelay: false,
  cuedSpeechInterpreter: false,
  oralInterpreter: false,
  tactileInterpreter: false,
  telephoneCallReminder: false,
  telephonicSignature: false,
  faceToFaceInterview: false,
  otherInfo: "",
  frequency: GeorgiaDfcsBenefits.AssistanceFrequency["One time"],
  whenAndHowLongInfo: "",
});

// Event for two-way binding
const emit = defineEmits(['update:modelValue', 'enter'])

const onInput = () => {
  for (const [name, key] of Object.entries(assistanceTypes)) {
    assistance.value[key] = selectedTypes.value.includes(key);
  }
  
  const emitValue = isRequired.value ? {...assistance.value} : undefined;
  emit('update:modelValue', emitValue);
};

onMounted(() => {
  if (props.modelValue) {
    isRequired.value = true;
    assistance.value = {...props.modelValue} as GeorgiaDfcsBenefits.RequiredAssistance;

    for (const [name, key] of Object.entries(assistanceTypes)) {
      if (props.modelValue[key]) {
        selectedTypes.value.push(key);
      }
    }
  }
})
</script>

<style scoped>
</style>